export const CENTER_SWITCHED_EVENT = "acton:center-switched";

// Fired whenever the offline outbox queue changes (enqueue/sync/retry/remove).
export const OUTBOX_CHANGED_EVENT = "acton:outbox-changed";

// Fired after session permissions are (re)loaded into storage via GetSessionValues.
export const PERMISSIONS_UPDATED_EVENT = "acton:permissions-updated";